import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";
import Slideshow from "../../assets/Slideshow/Slideshow";
import "./PersonalProjects.css";


import js1 from "../../assets/Images/jspractice/1.png";
import js2 from "../../assets/Images/jspractice/2.png";
import js3 from "../../assets/Images/jspractice/3.png";
import js4 from "../../assets/Images/jspractice/4.png";
import js5 from "../../assets/Images/jspractice/5.png";
import js6 from "../../assets/Images/jspractice/6.png";


const JavaScriptPractice = () => {
  const images = [js1,js2,js3,js4,js5,js6];

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="page-container">
      <Navbar />

      <div className="content-lo1-headings">
        <h1>JavaScript Practice</h1>
        <p>
          A collection of small JavaScript exercises I built during university —
          focused on APIs, state, and basic application logic.
        </p>
      </div>

      <div className="line"></div>

      <div className="breadcrumb-wrap" style={{ padding: "0.1rem 7.5rem" }}>
        <BreadcrumbHeader />
      </div>

      <div className="content-lo1">
        <div className="pp-layout">
          {/* LEFT */}
          <div className="pp-left">
            {/* Anchor navigation */}
            <div className="pp-anchors">
              <button onClick={() => scrollToId("overview")}>Overview</button>
              <button onClick={() => scrollToId("projects")}>Exercises</button>
              <button onClick={() => scrollToId("learning")}>
                What I Learned
              </button>
            </div>

            {/* OVERVIEW */}
            <section id="overview" className="pp-section">
              <h2>Overview</h2>
              <p>
                These were small practice projects, but they played a big role in
                helping me understand how JavaScript works in real situations.
                Instead of only following tutorials, I learned by building and
                experimenting.
              </p>
              <p>
                Each exercise focuses on fundamentals that appear in real
                applications: fetching data, handling user input, updating the UI,
                and managing simple state.
              </p>
            </section>

            {/* PROJECTS */}
            <section id="projects" className="pp-section">
              <h2>Exercises</h2>

              <h3>1) Currency Exchange</h3>
              <p>
                A simple currency converter that fetches live exchange rates and
                updates the result based on user input.
              </p>
              <ul>
                <li>API fetching</li>
                <li>User input handling</li>
                <li>Dynamic UI updates</li>
              </ul>
              <a
                href="/Portfolio/exchange.html"
                target="_blank"
                rel="noopener noreferrer"
                className="pp-link"
              >
                Open Currency Exchange 
              </a>

              <h3>2) Fake Store</h3>
              <p>
                A mini store interface built using the Fake Store API, focused on
                rendering real JSON data into a usable UI.
              </p>
              <ul>
                <li>Fetching product data</li>
                <li>Rendering lists dynamically</li>
                <li>Basic structure for product display</li>
              </ul>
              <a
                href="/Portfolio/fakestore.html"
                target="_blank"
                rel="noopener noreferrer"
                className="pp-link"
              >
                Open Fake Store 
              </a>

              <h3>3) Quiz App</h3>
              <p>
                A small quiz application to practice logic flow, scoring, and UI
                updates based on user choices.
              </p>
              <ul>
                <li>Question flow</li>
                <li>Score tracking</li>
                <li>Reset and replay logic</li>
              </ul>
              <a
                href="/Portfolio/quiz.html"
                target="_blank"
                rel="noopener noreferrer"
                className="pp-link"
              >
                Open Quiz App 
              </a>

              <h3>4) To-Do List</h3>
              <p>
                A classic to-do list focused on CRUD operations and keeping the UI
                in sync with stored data.
              </p>
              <ul>
                <li>Add / delete tasks</li>
                <li>Mark tasks as completed</li>
                <li>Local storage usage</li>
              </ul>
              <a
                href="/Portfolio/todo.html"
                target="_blank"
                rel="noopener noreferrer"
                className="pp-link"
              >
                Open To-Do List 
              </a>

              <h3>5) Virtual Library</h3>
              <p>
                An online book library where users can add, search, and filter
                books by different attributes.
              </p>
              <ul>
                <li>Form handling</li>
                <li>Filtering & searching</li>
                <li>Dynamic content rendering</li>
              </ul>
              <a
                href="/Portfolio/virtuallibrary.html"
                target="_blank"
                rel="noopener noreferrer"
                className="pp-link"
              >
                Open Virtual Library 
              </a>

              <h3>6) Student Administration</h3>
              <p>
                A small web storage exercise for managing a student list using
                browser storage.
              </p>
              <ul>
                <li>LocalStorage usage</li>
                <li>Add & list students</li>
                <li>Persistent data</li>
              </ul>
              <a
                href="/Portfolio/webstorage.html"
                target="_blank"
                rel="noopener noreferrer"
                className="pp-link"
              >
                Open Student Administration 
              </a>

              <div className="pp-snapshot">
                <div className="pp-snapshot-item">
                  <span className="pp-label">Focus</span>
                  <span className="pp-value">
                    JavaScript fundamentals, APIs, UI logic
                  </span>
                </div>
                <div className="pp-snapshot-item">
                  <span className="pp-label">Tools</span>
                  <span className="pp-value">
                    JavaScript, HTML, CSS, Fetch API
                  </span>
                </div>
              </div>
            </section>

            {/* LEARNING */}
            <section id="learning" className="pp-section">
              <h2>What I Learned</h2>
              <p>
                Working on multiple small projects helped me understand patterns
                instead of memorizing syntax. Each exercise reinforced the same
                fundamentals in a different context.
              </p>
              <ul>
                <li>How APIs work in practice</li>
                <li>How UI reacts to state changes</li>
                <li>Why small projects are powerful learning tools</li>
              </ul>
            </section>
          </div>

          {/* RIGHT */}
          <aside className="pp-right">
            {images.length > 0 ? (
              <Slideshow images={images} />
            ) : (
              <div className="slideshow-placeholder">
                <p>Slideshow Placeholder</p>
                <p>Add screenshots or demo videos of each app</p>
              </div>
            )}

            <div className="pp-caption">
              <p>
                
              </p>
            </div>
          </aside>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default JavaScriptPractice;
